import { render, staticRenderFns } from "./FilterTag.vue?vue&type=template&id=7278ff0e&scoped=true&"
import script from "./FilterTag.vue?vue&type=script&lang=ts&"
export * from "./FilterTag.vue?vue&type=script&lang=ts&"
import style0 from "./FilterTag.vue?vue&type=style&index=0&id=7278ff0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7278ff0e",
  null
  
)

export default component.exports